export default "__VITE_ASSET__60358b67__"